import { useState } from "react";
import Form from "react-bootstrap/Form";
import { FormControlProps } from "react-bootstrap";

import { ReactComponent as VisibilityOffSVG } from "../../app/assets/icons/visibility-off.svg";
import { ReactComponent as VisibilityOnSVG } from "../../app/assets/icons/visibility-on.svg";
import { ReactComponent as CloseIcon } from "../../app/assets/icons/close-icon.svg";
import ErrorMessageComponent from "../ErrorMessage/ErrorMessage";
import "./form-input.scss";

interface FormInputProps extends FormControlProps {
  value: string;
  label?: string;
  error?: string;
  clearFile?: () => void;
  showPasswordRule?: boolean;
  subtext?: string;
  labelClassName?: string;
  controlClassName?: string;
  inputType?: string;
  [key: string]: any;
}

const FormInput: React.FC<FormInputProps> = (props) => {
  const [passwordEyeIconVisibility, setPasswordEyeIconVisibility] =
    useState(false);

  const {
    label,
    type,
    required,
    // isInvalid,
    // isValid,
    value,
    touched,
    error,
    labelClassName = "",
    controlClassName = "",
    clearFile,
    disabled = false,
    showPasswordRule,
    subtext,
    inputType,
    size = "lg",
    ...rest
  } = props;

  const isPasswordType = type === "password";

  const hasRequiredChars = showPasswordRule && value.length >= 12;
  const hasNumber = showPasswordRule && /[0-9]/.test(value);
  const hasSymbol = showPasswordRule && /[!@#$%^&*]/.test(value);
  const hasUpperCase = showPasswordRule && /[A-Z]/.test(value);

  const togglePasswordEyeIcon = () => {
    setPasswordEyeIconVisibility((prevState) => !prevState);
  };

  return (
    <Form.Group className={`pos-relative w-100`}>
      {label && (
        <Form.Label className={labelClassName}>
          {label}
          {required && <span>*</span>}
        </Form.Label>
      )}
      {subtext && <div className="input-field-subtext">{subtext}</div>}

      {showPasswordRule && (
        <p className="fs-14 mb-1">
          Password must be at least{" "}
          <span className={hasRequiredChars ? "highlight-strikethrough" : ""}>
            12 characters long
          </span>{" "}
          and contain at least{" "}
          <span className={hasNumber ? "highlight-strikethrough" : ""}>
            one number
          </span>
          ,{" "}
          <span className={hasSymbol ? "highlight-strikethrough" : ""}>
            one symbol
          </span>
          , and{" "}
          <span className={hasUpperCase ? "highlight-strikethrough" : ""}>
            one upper-case letter
          </span>
          .
        </p>
      )}

      <div className="position-relative">
        <Form.Control
          className={
            isPasswordType
              ? `password-input ${controlClassName} ${disabled && "read-only"}`
              : `${controlClassName} ${disabled && "read-only"}`
          }
          aria-label={label}
          type={isPasswordType && passwordEyeIconVisibility ? "text" : type}
          disabled={disabled}
          size={size}
          value={value}
          {...rest}
        />
        {isPasswordType && !disabled && (
          <div
            className={`position-absolute valid-feedback ${
              isPasswordType ? "valid-feedback-password" : ""
            }`}
          >
            {!passwordEyeIconVisibility && (
              <VisibilityOnSVG
                className="toggle-eye"
                onClick={togglePasswordEyeIcon}
              />
            )}

            {passwordEyeIconVisibility && (
              <VisibilityOffSVG
                className="toggle-eye"
                onClick={togglePasswordEyeIcon}
              />
            )}
          </div>
        )}
        {inputType === "file" && value.length > 0 && (
          <div className="close-icon-media" onClick={clearFile}>
            <CloseIcon height={25} width={25} />
          </div>
        )}
      </div>

      <ErrorMessageComponent touched={touched} error={error} />
    </Form.Group>
  );
};

export default FormInput;
